
// Provider Network for one plan (#721 spec §8.2 steps 6-7, A.10). The MAPD
// sentence is today's, the supp sentence is Appendix A; PlanProvidersList
// prints the table and its intro. The out-of-network sentence that used to
// follow the recommended MAPD's table was dropped on advisor feedback
// (Kalena, 2026-09-30): the table's NO already says it.
import { mapGetters } from 'vuex'
import { CARE_COMPARE_URL } from '~/util/aep-recommendation'

export default {
    props: {
        plan: { type: Object, required: true },
    },
    computed: {
        ...mapGetters(['survey', 'carriersProvidersSearchLinks']),
        careCompareUrl: () => CARE_COMPARE_URL,
    },
}
